import { PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { NotificacoesEnviadasListWrapper } from './notificacoes-enviadas-list/NotificacoesEnviadasList'

/**
 * Visão administrativa de todas as notificações da plataforma. Rota própria (e não aba dentro de
 * `/apps/notificacoes`) para que a restrição de acesso fique no `allowedPermissions` da rota.
 */
const NotificacoesEnviadasPage = () => {
  const { t } = useT()

  return (
    <>
      <PageTitle description={t('pagina.notificacoesEnviadas.descricao')}>
        Notificações enviadas
      </PageTitle>
      <NotificacoesEnviadasListWrapper />
    </>
  )
}

export default NotificacoesEnviadasPage
